import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  // public/locales から翻訳ファイルをロード
  .use(Backend)
  // ユーザーのブラウザ言語を検出
  .use(LanguageDetector)
  // i18nextをreact-i18nextに渡す
  .use(initReactI18next)
  // i18nextの初期化
  .init({
    fallbackLng: 'ja',
    supportedLngs: ['ja', 'en'],
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
  });

export default i18n;
